<template>
  <div
    class="lightning-model-page__banner"
    :style="{ backgroundImage: `url(${backdropImageUrl})` }"
  >
    <v-img
      :src="noVehicleImage"
      class="lightning-model-page__banner__car-image"
      max-width="500"
      width="100%"
      height="auto"
      :eager="true"
    />
  </div>
  <v-container
    max-width="1280"
    class="lightning-model-page__header d-sm-flex align-center justify-space-between mb-0"
  >
    <div>
      <div class="lightning-model-page__header__model-name mb-2 mb-sm-0">2025 Ford F-150</div>
      <div
        class="lightning-model-page__header__trim-style text-grey-darken-1 d-flex justify-center justify-md-end"
      >
        Raptor
      </div>
    </div>
    <div>
      <div class="lightning-model-page__header__price">$103,140</div>
      <div
        class="lightning-model-page__header__trim-style text-center text-sm-end text-grey-darken-1"
      >
        MSRP
      </div>
    </div>
  </v-container>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { getCDNUrl } from '@/utils'

const props = defineProps<{
  settings: any
}>()

const cdnUrl = getCDNUrl()
const backdropImageUrl = `${cdnUrl}/lightning-model-page/admin/assets/city-backdrop.jpg`
const noVehicleImage = `${cdnUrl}/lightning-model-page/admin/assets/no-vehicle-image.png`

// Create computed properties that derive directly from props
// This ensures they update automatically when props change
const headerSettings = computed(() => {
  return props.settings?.header || {}
})

// Font sizes for model name
const modelNameFontSizeMobile = computed(() => {
  const fontSize = headerSettings.value?.modelName?.mobile?.fontSize || '20'
  const fontUnit = headerSettings.value?.modelName?.mobile?.fontSizeUnit || 'px'
  return `${fontSize}${fontUnit}`
})

const modelNameFontSizeDesktop = computed(() => {
  const fontSize = headerSettings.value?.modelName?.desktop?.fontSize || '28'
  const fontUnit = headerSettings.value?.modelName?.desktop?.fontSizeUnit || 'px'
  console.log('Computing model desktop font size:', fontSize, fontUnit)
  return `${fontSize}${fontUnit}`
})

// Font sizes for trim style
const trimStyleFontSizeMobile = computed(() => {
  const fontSize = headerSettings.value?.trimStyle?.mobile?.fontSize || '14'
  const fontUnit = headerSettings.value?.trimStyle?.mobile?.fontSizeUnit || 'px'
  return `${fontSize}${fontUnit}`
})

const trimStyleFontSizeDesktop = computed(() => {
  const fontSize = headerSettings.value?.trimStyle?.desktop?.fontSize || '16'
  const fontUnit = headerSettings.value?.trimStyle?.desktop?.fontSizeUnit || 'px'
  return `${fontSize}${fontUnit}`
})

// Font sizes for price
const priceFontSizeMobile = computed(() => {
  const fontSize = headerSettings.value?.price?.mobile?.fontSize || '20'
  const fontUnit = headerSettings.value?.price?.mobile?.fontSizeUnit || 'px'
  return `${fontSize}${fontUnit}`
})

const priceFontSizeDesktop = computed(() => {
  const fontSize = headerSettings.value?.price?.desktop?.fontSize || '28'
  const fontUnit = headerSettings.value?.price?.desktop?.fontSizeUnit || 'px'
  return `${fontSize}${fontUnit}`
})
</script>

<style scoped>
.lightning-model-page__banner {
  width: 100%;
  height: 300px;
  background-position: center;
  background-size: cover;
  position: relative;
}

.lightning-model-page__banner__car-image {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 30%);
  min-height: 400px;
}

.lightning-model-page__banner__car-image :deep(img) {
  height: 100% !important;
}

.lightning-model-page__banner__car-image {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 30%);
  min-height: 400px;
}

.lightning-model-page__banner__car-image :deep(img) {
  height: 100% !important;
}

.lightning-model-page__header {
  margin-top: 50px;
}

.lightning-model-page__header .lightning-model-page__header__model-name {
  font-size: v-bind('modelNameFontSizeDesktop');
  text-align: start;
}

.lightning-model-page__header .lightning-model-page__header__trim-style {
  font-size: v-bind('trimStyleFontSizeDesktop');
}

.lightning-model-page__header .lightning-model-page__header__price {
  font-size: v-bind('priceFontSizeDesktop');
  text-align: end;
}

@media all and (max-width: 767px) {
  .lightning-model-page__banner {
    height: 39vw;
    min-height: 100px;
  }

  .lightning-model-page__banner__car-image {
    min-height: auto;
  }

  .lightning-model-page__header {
    font-size: 2.25vw;
    line-height: normal;
    margin-top: 5vw;
  }

  .lightning-model-page__header .lightning-model-page__header__model-name {
    font-size: v-bind('modelNameFontSizeMobile');
    text-align: center;
  }

  .lightning-model-page__header .lightning-model-page__header__trim-style {
    font-size: v-bind('trimStyleFontSizeMobile');
  }

  .lightning-model-page__header .lightning-model-page__header__price {
    font-size: v-bind('priceFontSizeMobile');
    text-align: center;
  }
}
</style>
